
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import { stateType } from "./showVideoType";
function stateData() {
  return {
    videoList: [],
    showVideos: false,
    selectedVideo:''
  };
}
export default defineComponent({
  setup() {
    const states = reactive<stateType>(stateData());
    const route = useRoute();
    onMounted(() => {
      states.videoList = JSON.parse(route.query.videoList as string);
    });
    return {
      ...toRefs(states),
      ...useEvent(states)
    };
  },
});
const useEvent = (state:stateType) => {
    const onClickVideo = (s:any) => {
        state.selectedVideo = s.url
        state.showVideos = true
    }
    return {
        onClickVideo
    }
}
